module.exports = __webpack_public_path__ + "778f0f16d98af583eafb73dfd4b7149a.png";